import { Navigate, Outlet } from 'react-router-dom';
import { Spin } from 'antd';
import { useIsFederatedUser } from '@/features/auth/hooks/useIsFederatedUser';

/**
 * AccessManagementRoute
 *
 * Guarda das rotas de Gestão de acessos para cliente federado (RN09/CA08).
 *
 * Esconder os cards na Home não basta: a rota continua alcançável por URL
 * direta, favorito ou histórico, e a administração de usuários do cliente
 * federado é do IdP dele — não da plataforma, independentemente do perfil.
 * Usuário federado é devolvido à Home (`replace`, para o voltar do browser
 * não cair de novo aqui).
 *
 * Aguarda o `GET /auth/user-info` antes de decidir: renderizar a tela e
 * removê-la depois exibiria por um instante uma funcionalidade proibida.
 *
 * @example
 * ```tsx
 * <Route element={<AccessManagementRoute />}>
 *   <Route path="user-management" element={<UserManagementPage />} />
 * </Route>
 * ```
 *
 * @returns The nested route, or a redirect to the home for federated users
 * @since 1.0.0
 * @category Router
 */
export function AccessManagementRoute() {
  const { isFederated, isLoading } = useIsFederatedUser();

  if (isLoading) {
    return <Spin data-testid="access-management-route-loading" />;
  }

  if (isFederated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}

export default AccessManagementRoute;
